The details of the `CandidateProfile` to be uploaded.
